module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      invisible: !_vm.progress
    },
    attrs: {
      "id": "stepProgressBar"
    }
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      width: _vm.progress + '%'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c781e84!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/StepProgressBar.vue
// module id = 149
// module chunks = 0